import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=5f1335a9"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f1335a9')) {
      api.createRecord('5f1335a9', component.options)
    } else {
      api.reload('5f1335a9', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=5f1335a9", function () {
      api.rerender('5f1335a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/iframe-page/preview.vue"
export default component.exports